import ButtonField from '@/components/form-control/ButtonField'
import { DATA_TABLE_STATION_SETUP } from '@/constant/common'
import { Stack, Typography } from '@mui/material'
import FooterSetup from '../../common/FooterSetup'
import MenuHeader from '../../common/MenuHeader'
import RightGoogleMapSmall from '../../common/RightGoogleMapSmall'
import SetUpLayout from '../../common/SetUpLayout'
import StationTable from './StationTable'

type Props = {}

const StationData = (props: Props) => {

  const handleClick = () => {

  }

  return (
    <SetUpLayout
      title='Station'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMapSmall />}
      footer={<Stack p="25px 32px"><FooterSetup /></Stack>}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography sx={{ fontSize: "20px", lineHeight: "2.4" }}>Review Station Data</Typography>
        <Stack alignItems="center">
          <ButtonField
            startIcon={<></>}
            style={{
              height: '32px',
              minWidth: '89px',
              borderRadius: '5px',
            }}
            name="Done"
            onClick={handleClick}
          />
        </Stack>
      </Stack>
      <Stack>
        <Typography sx={{ color: "#000000", mb: "15px" }}>90 Standard, 5 Fertigation, 3 Filtration decoders</Typography>
      </Stack>
      <StationTable rows={DATA_TABLE_STATION_SETUP} />
    </SetUpLayout>
  )
}

export default StationData